// extracted by mini-css-extract-plugin
export default {"container":"ResourcesRoot_container__3TJIf"};